import { ClassData } from "../../../common/dtos/classes.type";
import RYBConnectClasses from "../../../common/services/classes.service";
import { Storage } from "../../../common/services/storage.service";
import { trackingService } from "../../../common/services/tracking.service";
import {
  getAgeLabelByAgeValue,
  parseAge,
} from "../../../common/utils/classes.util";
import { URL_PARAMETERS } from "../../../common/utils/const.util";
import { getIP } from "../../../common/utils/ip.util";
import { getUniqueLocationsList } from "../../../common/utils/locations.util";
import {
  getUrlParameterValue,
  setUrlParameter,
} from "../../../common/utils/url.util";
import { attachCampaignDataObject, getCookie } from "../../campaign";
import { DOMObserverService } from "./dom-observer.service";

interface FormData {
  name: string;
  email: string;
  phone: string;
  smsConsent: boolean;
}

export class ChildService {
  private static debounceTimer: { [key: string]: NodeJS.Timeout } = {};

  public static async addEventListeners() {
    DOMObserverService.watchForClass(
      ".box.child",
      "show",
      async () => await this.onStepOpen()
    );

    $(".form-loader").removeClass("active");
    const classes = new RYBConnectClasses();
    const data = await classes.getData();
    if (data) {
      if (ryb_connect_classes_data.wizard.steps["2"].length) {
        this.addFields(); // dynamic fields
      } else {
        this.setDropdownOptions(data);
        if ($(".box.child #location").length) {
          this.setLocationOptions(data);
        }
      }
    }

    $(".box.child select").on("change", async (e) => {
      const $select = $(e.target);
      const field = $select.attr("id");
      const value = $select.val() as any;
      if (field) {
        switch (field) {
          case "class-type":
            setUrlParameter(
              URL_PARAMETERS.GENDER,
              value === "null" ? null : value
            );
            break;
          case "age":
            setUrlParameter(
              URL_PARAMETERS.AGE,
              value === "null" ? null : value
            );
            break;
          case "location":
            setUrlParameter(
              URL_PARAMETERS.LOCATION,
              value === "null" ? null : value
            );
          default:
            setUrlParameter(field, value);
        }
      }
    });

    $("#name, #email, #phone").on("input", (e) => {
      const $input = $(e.target);
      const field = $input.attr("id");
      if (!field) {
        return;
      }
      clearTimeout(this.debounceTimer[field]);

      // Set a new debounce timer
      this.debounceTimer[field] = setTimeout(() => {
        switch (field) {
          case "name":
            this.validateField(
              field,
              this.validateName($input.val() as string)
            );
            break;
          case "email":
            this.validateField(
              field,
              this.validateEmail($input.val() as string)
            );
            break;
          case "phone":
            this.validateField(
              field,
              this.validatePhone($input.val() as string)
            );
            break;
        }
      }, 500);
    });

    $(".box.child .form-submit").on("click", () => {
      this.hideError(".main-error-message");
      this.handleFormSubmit();
    });

    document
      .querySelector("#location.location-select")
      ?.addEventListener("click", (event) => {
        document
          .querySelector(".dropdown-location.select")
          ?.classList.toggle("show");
        event.stopPropagation();
      });

    window.addEventListener("click", (event) => {
      const dropdown = document.querySelector(".dropdown-location.select");
      const locationSelect = document.querySelector(
        "#location.location-select"
      );

      if (
        dropdown?.classList.contains("show") &&
        !dropdown.contains(event.target as Node) &&
        !locationSelect?.contains(event.target as Node)
      ) {
        dropdown.classList.remove("show");
      }
    });
  }

  private static addFields() {
    const elementWrapper = document.querySelector(".box.child > .step-box");
    const elementsToHide =
      elementWrapper?.querySelectorAll(".dropdown-wrapper");
    elementsToHide?.forEach((element: any) => {
      element.style.display = "none";
    });
    ryb_connect_classes_data.wizard.steps["2"].forEach((item) => {
      const dropdownDiv = document.createElement("div");
      dropdownDiv.className = "dropdown-wrapper";

      const select = document.createElement("select");
      select.className = "standard-select";
      select.name = item.query_parameter;
      select.id = item.query_parameter;

      item.options.forEach((option) => {
        const optionElement = document.createElement("option");
        optionElement.value = option.option_value;
        optionElement.textContent = option.option_label;
        const urlParameter = getUrlParameterValue(item.query_parameter);
        if (urlParameter) {
          optionElement.selected = urlParameter === option.option_value;
        } else {
          optionElement.selected = option.is_default === "1";
          if (option.is_default === "1") {
            if (option.option_value !== "null") {
              setUrlParameter(item.query_parameter, option.option_value);
            }
          }
        }

        select.appendChild(optionElement);
      });
      dropdownDiv.appendChild(select);
      elementWrapper?.appendChild(dropdownDiv);
    });
  }

  private static validateField(field: string, isValid: boolean) {
    const selector = `.step-box #${field}`;
    if (isValid) {
      this.hideError(selector);
    } else {
      let message = "";
      switch (field) {
        case "name":
          message = "Please enter a valid name (at least 2 characters).";
          break;
        case "email":
          message = "Please enter a valid email address.";
          break;
        case "phone":
          message = "Please enter a valid phone number.";
          break;
      }
      this.showError(selector, message);
    }
  }

  private static async handleFormSubmit() {
    const formData = this.getFormData();
    const isFormBoxStep = document.querySelector(
      ".box.child.show .form-box.step-box.show"
    );
    if (this.isFormEmpty(formData) && !isFormBoxStep) {
      this.onNextStep();
      return;
    }
    if (!this.validateFormData(formData)) {
      console.error(
        "Please complete all fields if you start filling out the form"
      );
      return;
    }

    Storage.set("name", formData.name);
    Storage.set("email", formData.email);
    Storage.set("phone", formData.phone);
    try {
      const response = (await this.submitCRMData(formData)) as any;
      if (response.success) {
        this.onNextStep();
      } else {
        trackingService.captureException(
          new Error(
            `${window.location.host} | Submit CRM data to GoHighLevel - GHL API responded with error in wizard step child`
          ),
          {
            devMessage:
              "Check plugin logs, either the token was not refreshed or their API is down",
            response: response,
          }
        );
        this.onNextStep();

        const message =
          response?.data?.message ||
          "We experienced an issue processing your data. Please check your information and make sure that it's valid.";
        this.showError(".main-error-message", message);
      }
    } catch (error) {
      trackingService.captureException(
        new Error(
          `${window.location.host} | Submit CRM data to GoHighLevel - GHL API responded with error in wizard step child`
        ),
        {
          devMessage:
            "Check plugin logs, either the token was not refreshed or their API is down",
          error: error,
        }
      );
      console.error("error : ", error);
      const message =
        "We experienced an issue processing your data. Please check your information and make sure that it's valid.";
      this.showError(".main-error-message", message);
      this.onNextStep();
    }
    try {
      await this.submitGAData(formData);
    } catch (error) {
      console.error("Could not send data to the google analytics.");
    }
  }

  private static getFormData(): FormData {
    return {
      name: $("#name").val() as string,
      email: $("#email").val() as string,
      phone: $("#phone").val() as string,
      smsConsent: $("#sms-consent").is(":checked"),
    };
  }

  private static isFormEmpty(data: FormData): boolean {
    return (
      !data.name?.trim() &&
      !data.email?.trim() &&
      !data.phone?.trim() &&
      !data.smsConsent
    );
  }

  private static validateFormData(data: FormData): boolean {
    const isNameValid = this.validateName(data.name);
    const isEmailValid = this.validateEmail(data.email);
    const isPhoneValid = this.validatePhone(data.phone);

    if (!isNameValid) {
      this.showError(
        ".step-box #name",
        "Please enter a valid name (at least 2 characters)."
      );
    } else {
      this.hideError(".step-box #name");
    }

    if (!isEmailValid) {
      this.showError(".step-box #email", "Please enter a valid email address.");
    } else {
      this.hideError(".step-box #email");
    }

    if (!isPhoneValid) {
      this.showError(".step-box #phone", "Please enter a valid phone number.");
    } else {
      this.hideError(".step-box #phone");
    }

    return isNameValid && isEmailValid && isPhoneValid;
  }

  private static validateName(name: string): boolean {
    return name.trim().length >= 2;
  }

  private static validatePhone(phone: string): boolean {
    const phoneRegex = /^[+]?[0-9\s()-]{7,15}$/;
    return phoneRegex.test(phone);
  }

  private static showError(selector: string, message: string): void {
    const $input = $(selector);
    let $error = $input.next(".error-message");
    if (!$error.length) {
      $error = $("<div>").addClass("error-message");
      $input.after($error);
      $($error).show();
    }
    $error.text(message);
  }

  private static hideError(selector: string): void {
    const $input = $(selector);
    $input.next(".error-message").remove();
  }

  private static validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  private static async submitCRMData(formData: FormData) {
    const nonce = ryb_connect_ajax?.nonce;
    if (!nonce) {
      throw new Error("Security nonce not found");
    }

    const currentUrl = new URL(window.location.href);
    const stepParam = currentUrl.searchParams.get("step");
    let updatedStep = stepParam ? parseInt(stepParam, 10) + 1 : 1;

    currentUrl.searchParams.set("step", updatedStep.toString());

    const gender = getUrlParameterValue(URL_PARAMETERS.GENDER);
    const age = getUrlParameterValue(URL_PARAMETERS.AGE);

    const response = await $.ajax({
      url: `https://${window.location.host}/wp-json/ryb/v1/ghl?timestamp=${Date.now()}`,
      method: "POST",
      contentType: "application/json",
      data: JSON.stringify({
        body: attachCampaignDataObject(
          {
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            dnd: false,
            dndSettings: {
              SMS: {
                status: formData.smsConsent ? "inactive" : "active", // discussed with Sebi - inactive is when smsConsent is checked
                message: "Source Web Funnel",
              },
            },
            provider_id: 1, // You might want to make this configurable
            customFields: [
              {
                key: "age",
                field_value: age ? getAgeLabelByAgeValue(age) : "All",
              },
              {
                key: "gender",
                field_value:
                  gender === "female" || gender === "male" ? gender : "All",
              },
              {
                key: "last_funnel_url",
                field_value: currentUrl.toString(),
              },
              {
                key: "step_1",
                field_value: "Step 2 | Age & Gender",
              },
            ],
        source: "website",
      })
      })
    });

    if(response.success === true && response?.data?.contact?.id) {
      const contactId = response?.data?.contact?.id;
      localStorage.setItem('ghlContactId', contactId);
      const tagsResponse = await $.ajax({
        url: `https://${window.location.host}/wp-json/ryb/v1/ghl?timestamp=${Date.now()}`,
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify({
          request_url: `https://services.leadconnectorhq.com/contacts/${contactId}/tags`,
          include_location_id: false,
          body: {
            tags: document.querySelector("#class-finder.template-trials")
          ? ["trial"]
          : ["webFunnel"],
          }
        })
      })

      if (tagsResponse?.success === false) {
        trackingService.captureException(
          new Error(
            `${window.location.host} | Submit CRM data (TAGS) to GoHighLevel - GHL API responded with error in wizard step child`
          ),
          {
            devMessage:
              "Check plugin logs, the tag request failed, so the users will not have tags",
            response: response,
          }
        );
      }
    }

    return response;
  }

  private static async submitGAData(formData: FormData) {
    const classData = getCookie("classData");
    const eventData = attachCampaignDataObject({
      site_name: window.location.host,
      event: "lead created", // for enrollment - enroll, for contact form - lead created
      name: formData.name,
      email: formData?.email ? formData.email : "No email provided",
      timestamp: Date.now(),
      ip: await getIP(),
      page_title: document.querySelector("title")?.innerText,
      class_data: classData ? JSON.parse(atob(classData)) : {},
    });
    fetch("https://a.cloud.dive.games/ryb/events", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(eventData),
    })
      .then((data) => {
        console.log("Success:", data);
      })
      .catch((error) => {
        console.error("Error:", error);
        trackingService.captureException(
          new Error(
            `${window.location.host} | a.cloud.dive.games API returned error on request in wizard - child service step`
          ),
          {
            devMessage: "a.cloud.dive.games returned error on request",
            requestObject: eventData,
            error: error,
          }
        );
      });
  }

  public static async onStepOpen() {
    const classes = new RYBConnectClasses();
    await classes.getData();
  }

  private static setDropdownOptions(data: ClassData[]) {
    const $ageSelect = $("#age");
    const $ageOptions = $ageSelect.find("option");
    if ($ageOptions) {
      $ageOptions.each(function () {
        const $option = $(this);
        const optionValue = $option.val() as string;
        if (!optionValue) return;
        if (optionValue === "null") {
          return;
        }

        const optionAge = parseAge(optionValue);
        let shouldRemove = true;
        for (const item of data) {
          let dataAge;
          if (item.min_age && item.max_age) {
            dataAge = parseAge(`${item.min_age}-${item.max_age}`);
          } else if (item.min_age && !item.max_age) {
            dataAge = parseAge(`${item.min_age}-${item.min_age}`);
          } else if (!item.min_age && item.max_age) {
            dataAge = parseAge(`${item.max_age}-${item.max_age}`);
          } else {
            continue;
          }

          if (
            dataAge.start <= optionAge.end &&
            optionAge.start <= dataAge.end
          ) {
            shouldRemove = false;
            break;
          }
        }

        if (shouldRemove) {
          $option.remove();
        }
      });
    }

    return $ageSelect.find?.("option")?.length > 0;
  }

  private static setLocationOptions(data: ClassData[]) {
    const availableLocations = getUniqueLocationsList(data);
    const locationSelect = document.querySelector(
      "#location .dropdown-location"
    ) as HTMLSelectElement;

    if (locationSelect) {
      availableLocations.forEach((location) => {
        const option = document.createElement("li");
        option.setAttribute("value", location.value);
        option.innerHTML = `<strong>${location.label}</strong><br/><span>${location.labelDescription}</span>`;

        // Add click event listener directly to the element
        option.addEventListener("click", (event) => {
          const clickedElement = event.currentTarget as HTMLElement;
          const value = clickedElement.getAttribute("value");

          if (value) {
            setUrlParameter(URL_PARAMETERS.LOCATION, value);

            $("#location.location-select .default").text(value);
          }
        });

        locationSelect.appendChild(option);
      });
    }
  }

  private static onNextStep() {
    $(".box.show").removeClass("show");
    $(".box.classes").addClass("show");
    setUrlParameter(URL_PARAMETERS.STEP, "2");
  }
}
